type ParamType = string | number | boolean;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
    /**
     * Add prefix to string
     *
     * @example 'hello'.prefix('world') => 'worldhello'
     * @param pre prefix string
     * @returns string
     */
    prefix(pre: string): string;

    /**
     * Convert a string to uppercase first character
     *
     * @example 'hello'.toUpperFirstCharacter() => 'Hello'
     * @returns string
     */
    toUpperFirstCharacter(): string;

    /**
     * Convert a string to uppercase from index to index
     *
     * @example 'hello'.toUpperCharacter(1, 3) => 'hELlo'
     * @param from start index
     * @param to end index
     * @returns string
     */
    toUpperCharacter(from: number, to: number): string;

    /**
     * Convert a string to uppercase with separator
     *
     * @example 'hello-world'.toUpperWithSeparator('-', 1) => 'hello-WORLD'
     * @param separator separator
     * @param index index
     * @returns string
     */
    toUpperWithSeparator(separator: string, index: number): string;

    /**
     * Convert a string to lowercase first word
     *
     * @example 'Hello World'.toLowerFirstWord() => 'hello World'
     * @returns string
     */
    toLowerFirstWord(): string;

    /**
     * Replace string with params
     *
     * @example 'Hello {name}'.replaceWithParams({name: 'World'}) => 'Hello World'
     * @param params
     * @returns string
     */
    replaceWithParams(params: Record<string, ParamType>): string;

    /**
     * Check if string is equal to another string ignoring case
     *
     * @example 'Hello'.isEqualsIgnoreCase('hello') => true
     * @param str string to compare
     * @returns boolean
     */
    isEqualsIgnoreCase(str: string): boolean;
}

String.prototype.prefix = function (pre: string) {
    return pre + this;
};

String.prototype.toUpperFirstCharacter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.toUpperCharacter = function (from: number, to: number) {
    const fromIdx = from > 0 ? from - 1 : 0;
    const first = this.slice(0, fromIdx);
    const last = this.slice(to, this.length);
    const rest = this.slice(fromIdx, to);
    return [first, rest.toUpperCase(), last].join('');
};

String.prototype.toUpperWithSeparator = function (separator: string, index: number) {
    const split = this.split(separator);
    return split.map((s, i) => (i === index ? s.toUpperCase() : s)).join(separator);
};

String.prototype.toLowerFirstWord = function () {
    const [first, ...others] = this.split(' ');
    return [first.toLowerCase(), ...others].join(' ');
};

String.prototype.replaceWithParams = function (params: Record<string, ParamType>) {
    if (!params) {
        return this.toString();
    }
    const templateMatcher = /{\s?([^{}\s]*)\s?}/g;

    const getValue = (object: Record<string, ParamType>, key: string) => {
        return object[key].toString();
    };

    return this.replace(templateMatcher, (substring: string, b: string) => {
        const r = getValue(params, b);
        return r ?? substring;
    });
};

String.prototype.isEqualsIgnoreCase = function (str: string) {
    return this.toLowerCase() === str.toLowerCase();
};
